import React from 'react'
import { buildQuery } from './graphql'
import { useBlogItemContext } from './Context'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { useRole } from '@ztechapps/common.hook'
import type { SetOptional } from 'type-fest'
import { blogPermissions } from '@ztechapps/blog.common'

type BlogInlineInputProps = SetOptional<InlineInputProps, 'mutationConfig' | 'initialValues'>

export const BlogInlineInput = ({
  parentInputComponent,
  name,
  mutationConfig,
  queryName,
  canEdit,
  ...rest
}: BlogInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  const { document } = useBlogItemContext()
  const initialValues = { _id: document?._id, [name]: document?.[name] }

  const defaultMutationConfig = React.useMemo(() => {
    return buildQuery(queryName ?? name).updateConfig
  }, [queryName, name])

  const { hasRole } = useRole({ roleName: blogPermissions.canEdit.value })
  canEdit = canEdit ?? hasRole

  if (!mutationConfig) {
    mutationConfig = defaultMutationConfig
  }

  return <ParentInput {...{ initialValues, canEdit, mutationConfig, name, ...rest }} />
}
